<div class="mt-8 mb-4">

    @let group = (group$ | async);

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between">
            <app-btn-back [routeTo]="'/groups'"></app-btn-back>
        </div>

        @if (group?.memberStatus == membershipStatus.active) {
        <div class="flex justify-end items-end relative">
            <app-btn-fab (click)="toggleDropdown($event)" icon="fas fa-ellipsis-vertical"
                bgColor="bg-transparent hover:bg-gray-200 active:bg-gray-300"></app-btn-fab>
            <div class="min-w-48 z-50 absolute top-full right-0 mt-1 {{ dropdownPopoverShow ? 'block' : 'hidden'}}">
                <div
                    class="bg-white text-base p-1 list-none text-left rounded-lg shadow-lg min-w-48 border border-gray-100">
                    <a [routerLink]="['members']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-users mr-2 leading-relaxed"></i>
                        Members
                    </a>
                    <a [routerLink]="['prayers']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-praying-hands mr-2 leading-relaxed"></i>
                        Prayers
                    </a>
                    <a [routerLink]="['events']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-calendar mr-2 leading-relaxed"></i>
                        Events
                    </a>
                    <a [routerLink]="['giving']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-credit-card mr-2 leading-relaxed"></i>
                        My Giving
                    </a>
                    <a [routerLink]="['funding']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-hand-holding-heart mr-2 leading-relaxed"></i>
                        Funding Requests
                    </a>
                    <a (click)="onViewProfile()" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fa fa-user-astronaut mr-2 leading-relaxed"></i>
                        My Profile in Group
                    </a>
                    @if ((myRoles$ | async)?.admin || (myRoles$ | async)?.treasurer) {
                    <a [routerLink]="['accounting']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-calculator mr-2 leading-relaxed"></i>
                        Accounting
                    </a>
                    }
                    <a [routerLink]="['affiliation']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-sitemap mr-2 leading-relaxed"></i>
                        Governance & Affiliation
                        @if ((myRoles$ | async)?.admin && (pendingAffiliationInvites$ | async); as inviteCount) {
                        <span class="ml-1 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-500 text-white"
                            title="Pending organization invitations">{{ inviteCount }}</span>
                        }
                    </a>
                    @if (((myRoles$ | async)?.admin || (myRoles$ | async)?.management) && group?.memberStatus ==
                    membershipStatus.active) {
                    <a [routerLink]="['edit']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fas fa-edit mr-2 leading-relaxed"></i>
                        Edit Group
                    </a>
                    }
                </div>
            </div>
        </div>
        }
    </div>

    <div class="bg-blueGray-100 mb-4">
        <div class="text-center flex justify-between items-center">
            <h6 class="text-primary-500 text-lg font-bold uppercase">
                {{group?.name}}
            </h6>
            <div class="flex flex-row gap-4 justify-center items-center">
                <span class="text-sm hidden lg:block text-blueGray-400">Membership:</span>
                <app-btn-member-status [status]="group?.memberStatus" [isDisabled]="true"></app-btn-member-status>
            </div>
        </div>
    </div>

    <div class="flex flex-col shadow-none bg-blueGray-100 border-0">

        <div class="flex flex-col-reverse lg:flex-row">
            <div class="flex flex-wrap w-full lg:w-3/6 lg:mr-6">
                <div class="w-full lg:w-12/12">
                    <div class="relative w-full mb-3">

                        <!-- Active Funding Promo Card -->
                        @let activeFunding = (activeFunding$ | async);
                        @if (activeFunding) {
                        <div
                            class="w-full mb-8 bg-gradient-to-r from-rose-500 to-pink-600 rounded-2xl p-6 text-white shadow-lg relative overflow-hidden">
                            <div
                                class="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-white bg-opacity-10 blur-xl">
                            </div>
                            <div class="flex items-center gap-2 mb-2">
                                <i class="fa fa-hand-holding-heart text-xl"></i>
                                <span class="text-xs uppercase font-bold tracking-wider opacity-90">Featured
                                    Funding</span>
                            </div>
                            <h4 class="text-xl font-bold mb-2">{{ activeFunding.title }}</h4>
                            <p class="text-sm opacity-90 mb-4 leading-relaxed">{{ activeFunding.description }}</p>

                            @let target = activeFunding.targetAmount || 0;
                            @let raised = activeFunding.raisedAmount || 0;
                            @let progressPercent = target > 0 ? (raised / target * 100) : 0;
                            @let clampedProgress = progressPercent > 100 ? 100 : progressPercent;

                            <div class="w-full mb-4">
                                <div class="flex justify-between items-center text-xs mb-1 font-bold">
                                    <span>Progress: {{ progressPercent | number: '1.0-0' }}%</span>
                                    <span>{{ raised | currency: (group?.currency || 'USD') }} raised</span>
                                </div>
                                <div class="w-full bg-white bg-opacity-20 rounded-full h-2 overflow-hidden">
                                    <div class="bg-white h-2 rounded-full transition-all duration-500"
                                        [style.width.%]="clampedProgress"></div>
                                </div>
                            </div>

                            <div
                                class="flex flex-wrap gap-3 items-center justify-between border-t border-white border-opacity-20 pt-4">
                                <div>
                                    <span class="text-[10px] uppercase font-semibold opacity-75 block">Goal
                                        Target</span>
                                    <span class="text-lg font-black">{{ target | currency: (group?.currency || 'USD')
                                        }}</span>
                                </div>
                                <div class="flex gap-2">
                                    <a [routerLink]="['funding']"
                                        class="bg-white text-rose-600 font-bold text-xs py-2.5 px-4 rounded-xl shadow transition-all hover:bg-rose-50">
                                        Support Fund
                                    </a>
                                    <a [routerLink]="['funding']"
                                        class="bg-white bg-opacity-25 hover:bg-opacity-30 border border-white border-opacity-35 text-white font-bold text-xs py-2.5 px-4 rounded-xl transition-all">
                                        View All
                                    </a>
                                </div>
                            </div>
                        </div>
                        }

                        <div class="w-full lg:w-12/12 mb-8">
                            <div class="relative w-full mb-3">
                                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                    Description
                                </label>
                                <span
                                    class="text-blueGray-600 text-sm whitespace-pre-line">{{group?.description}}</span>
                            </div>
                        </div>
                        <div class="w-full lg:w-12/12 mb-8">
                            <div class="flex flex-row justify-between items-start w-full">
                                <div class="flex flex-col">
                                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                        Address
                                    </label>
                                    <span
                                        class="text-blueGray-600 normal-case text-sm">{{group?.address?.addressLine1}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm">
                                        {{group?.address?.addressLine2}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm"> {{group?.address?.city}}</span>
                                    <span class="text-blueGray-600 normal-case text-sm">
                                        {{group?.address?.country}}</span>
                                </div>
                                @if (group?.location) {
                                <button (click)="openMap()" type="button"
                                    class="text-primary-300 hover:text-primary-700 transition-colors ml-4 self-start focus:outline-none"
                                    title="View Map">
                                    <i class="fas fa-map-location-dot text-xl"></i>
                                </button>
                                }
                            </div>
                        </div>
                        @if (group?.primaryContact?.contact) {
                        <div class="w-full lg:w-12/12 mb-8">
                            <div class="w-full">
                                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                    Primary Contact
                                </label>
                                <span
                                    class="text-blueGray-600 capitalize text-sm">+{{group?.primaryContact?.phoneCode}}</span>
                                <span class="text-blueGray-600 text-sm">
                                    {{group?.primaryContact?.contact}}</span>
                            </div>
                        </div>
                        }
                        @if (group?.secondaryContact?.contact) {
                        <div class="w-full lg:w-12/12 mb-8">
                            <div class="w-full">
                                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                    Secondary Contact
                                </label>
                                <span
                                    class="text-blueGray-600 capitalize text-sm">+{{group?.secondaryContact?.phoneCode}}</span>
                                <span class="text-blueGray-600 text-sm">
                                    {{group?.secondaryContact?.contact}}</span>
                            </div>
                        </div>
                        }
                        <div class="w-full lg:w-12/12 mb-8">
                            <div class="w-full">
                                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                    Email
                                </label>
                                <span class="text-blueGray-600 text-sm">{{group?.email}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (group) {
            <div class="w-full lg:w-3/6">
                @if (group.imageUrl) {
                <div class="relative flex rounded-t justify-center items-center mb-6">
                    <img alt="..." [src]="group.imageUrl"
                        class="shadow-xl rounded w-full lg:w-3/6 object-cover mx-auto align-middle border-none max-h-[250px] lg:max-h-[400px]" />
                </div>
                } @else {
                <div
                    class="bg-primary-100 uppercase text-primary-500 text-4xl flex justify-center items-center text-center shadow-xl rounded w-full mb-6 min-h-[250px] lg:max-h-[400px]">
                    {{group.name | initials}}
                </div>
                }
            </div>
            }
        </div>

        <!-- Affiliated Organization: where this church sits in its organization's hierarchy -->
        @let affiliation = (affiliation$ | async);
        @if (affiliation?.organization) {
        <div class="w-full mb-8 pt-6 border-t border-blueGray-200">
            <h6 class="text-blueGray-600 text-sm font-bold uppercase mb-4">
                Affiliated Organization
            </h6>
            <div class="bg-white p-4 rounded-lg shadow-sm">
                <div class="flex items-start gap-3 min-w-0">
                    @if (affiliation?.organization?.logoUrl) {
                    <img [src]="affiliation?.organization?.logoUrl" [alt]="affiliation?.organization?.name"
                        class="w-10 h-10 rounded-full object-cover shrink-0" />
                    } @else {
                    <div class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 shrink-0">
                        <i class="fas fa-sitemap text-lg"></i>
                    </div>
                    }
                    <div class="min-w-0">
                        <span class="text-sm font-bold text-blueGray-800 block">{{ affiliation?.organization?.name }}</span>
                        <!-- Breadcrumb: the church's place in the hierarchy -->
                        <nav aria-label="Position in the organization" class="flex flex-wrap items-center gap-1 mt-1 text-xs text-blueGray-500">
                            @for (unit of affiliation?.lineage; track unit.id) {
                            <span class="whitespace-nowrap">
                                {{ unit.name }}
                                @if (unit.levelName) {
                                <span class="text-blueGray-400">({{ unit.levelName }})</span>
                                }
                            </span>
                            <i class="fas fa-chevron-right text-[8px] text-blueGray-300"></i>
                            }
                            <span class="font-semibold text-primary-600 whitespace-nowrap">{{ group?.name }}</span>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        }

        <!-- Group Configurations Section -->
        @if (group?.memberStatus == membershipStatus.active) {
        <div class="w-full mb-8 pt-6 border-t border-blueGray-200">
            <h6 class="text-blueGray-600 text-sm font-bold uppercase mb-4">
                Group Configurations
            </h6>
            <div class="grid grid-cols-1 gap-4">
                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-robot text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">AI Receipt Reader</span>
                        <span class="text-sm font-semibold text-blueGray-700">
                            {{ group?.isAiEnabled !== false ? 'Enabled' : 'Disabled' }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-comments text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">Group Chat</span>
                        <span class="text-sm font-semibold text-blueGray-700">
                            {{ group?.isChatAllowed !== false ? 'Allowed' : 'Not Allowed' }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-coins text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">Default Currency</span>
                        <span class="text-sm font-semibold uppercase text-blueGray-700">
                            {{ group?.currency || 'USD' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>